<template>
  <div>
    <loading
      name="lp"
      :active.sync="isLoading"
      :can-cancel="false"
      :is-full-page="true"
    ></loading>
    <base-header class="pb-6">
      <div class="row align-items-center py-0"></div>
    </base-header>
    <div class="container-fluid mt--6">
      <div>
        <card
          class="no-border-card"
          body-classes="px-0 pb-1"
          footer-classes="pb-2"
        >
          <template slot="header">
            <h3 class="mb-0">Homework</h3>
            <p class="text-sm mb-0">Check and revise homework</p>
          </template>
          <div class="row card-body">
            <div class="col-lg-12">
              <el-select
                class="select-primary pagination-select"
                v-model="filter2"
                placeholder="Select"
              >
                <el-option
                  class="select-primary"
                  :key="1"
                  label="Actual"
                  :value="1"
                ></el-option>
                <el-option
                  class="select-primary"
                  :key="2"
                  label="All"
                  :value="2"
                ></el-option>
              </el-select>
            </div>

            <div class="col-lg-2">
              <base-input label="Start date">
                <flat-picker
                  class="form-control datepicker"
                  :config="{ allowInput: true }"
                  v-model="filter.start"
                ></flat-picker>
              </base-input>
            </div>
            <div class="col-lg-2">
              <base-input label="End date">
                <flat-picker
                  :config="{ allowInput: true, minDate: filter.start }"
                  class="form-control datepicker"
                  v-model="filter.end"
                ></flat-picker>
              </base-input>
            </div>
            <div class="col-lg-8">
              <label>Criteria</label>
              <table>
                <tr>
                  <td valign="top">
                    <el-select
                      class="select-primary pagination-select"
                      v-model="filter.searchtype"
                      placeholder="Select"
                      @change="filter.id = ''"
                    >
                      <el-option
                        class="select-primary"
                        :key="1"
                        label="Teacher"
                        :value="1"
                      ></el-option>
                      <el-option
                        class="select-primary"
                        :key="2"
                        label="Class code"
                        :value="2"
                      ></el-option>
                    </el-select>
                  </td>
                  <td valign="top" width="200px">
                    <el-select
                      v-if="filter.searchtype === 1"
                      class="select-primary pagination-select"
                      v-model="filter.id"
                      placeholder="Teacher"
                    >
                      <el-option
                        class="select-primary"
                        v-for="item in teachers"
                        :key="item.id"
                        :label="item.fullname"
                        :value="item.id"
                      ></el-option>
                    </el-select>
                    <base-input
                      v-if="filter.searchtype === 2"
                      name="code"
                      type="success"
                      v-model="filter.id"
                      placeholder="Code"
                    ></base-input>
                  </td>
                  <td valign="top">
                    <base-button type="primary" @click.prevent="onGo"
                      >Go</base-button
                    >
                  </td>
                </tr>
              </table>
            </div>

            <div class="col-lg-8">
              
              <base-button type="info" @click.prevent="onRefresh" icon>
                <span class="btn-inner--icon">
                  <i class="ni refresh-02"></i> </span
                >Refresh
              </base-button>
            </div>
            <div class="col-lg-4">
                <base-input
                  v-model="search"
                  prepend-icon="fas fa-search"
                  placeholder="Student..."
                ></base-input>
             
            </div>
            <el-table
              :border="true"
              :data="
                tableData.filter(
                  (c) =>
                    ((isactual(c.publish) && filter2 === 1) || filter2 === 2) &&
                    (!search ||
                      (search &&
                        c.studentname.toLowerCase().indexOf(search.toLowerCase()) > -1))
                )
              "
              row-key="id"
              header-row-class-name="thead-light"
            >
              <el-table-column
                prop="classcode"
                label="Code"
                width="120px"
              ></el-table-column>
              <el-table-column label="Name" width="150px">
                <div slot-scope="{ row }">
                  {{ row.studentname }}
                </div>
              </el-table-column>
              <el-table-column prop="title" label="title" width="220px">
                <div slot-scope="{ row }">
                  {{ row.title }} <br />
                  <base-button
                    type="primary"
                    size="sm"
                    @click="
                      modaltask = true;
                      task = row;
                    "
                    >Show task</base-button
                  >
                </div>
              </el-table-column>
              <el-table-column label="published" width="220px">
                <div slot-scope="{ row }">
                  {{ row.publish }} <br />
                  <base-button
                    type="primary"
                    size="sm"
                    @click="
                      modalresponse = true;
                      task = row;
                    "
                    >Show response</base-button
                  >
                </div>
              </el-table-column>
              <el-table-column
                prop="mark"
                label="mark"
                width="100px"
              ></el-table-column>
              <el-table-column
                width="80px"
                align="center"
                label=""
                fixed="right"
              >
                <div slot-scope="{ row }">
                  <base-button
                    @click.native="
                      modalresult = true;
                      result.mark = row.mark;
                      result.teachernotes = row.teachernotes;
                      result.id = row.id;
                      mark = row.mark;
                    "
                    class="edit"
                    type="warning"
                    size="sm"
                    icon
                  >
                    <i class="text-white ni n-edit"></i>
                  </base-button>
                </div>
              </el-table-column>
            </el-table>
          </div>
        </card>
      </div>
    </div>
    <modal :show.sync="modaltask" size="lg" bodyClasses="modalbody">
      <h6 slot="header" class="modal-title">Task</h6>
      <div class="row">
        <div class="col-lg-8">
          <base-input class="mb-3" label="Title">
            {{ task.title }}
          </base-input>
        </div>
        <div class="col-lg-4">
          <base-input class="mb-3" label="Level">
            {{ task.levelname }}
          </base-input>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-12">
          <base-input class="mb-3" label="Description">
            {{ task.description }}
          </base-input>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-12">
          <div
            v-for="file in task.files"
            :key="file.name"
            style="font-size: 12px"
          >
            <a target="blank" :href="fileurl + file.name">
              <i class="text-black ni file-text"></i>
              {{ file.name.substring(file.name.indexOf("_") + 1) }}
            </a>
          </div>
        </div>
      </div>
    </modal>

    <modal :show.sync="modalresponse" size="lg" bodyClasses="modalbody">
      <h6 slot="header" class="modal-title">Response</h6>
      <div class="row">
        <div class="col-lg-12">
          <base-input class="mb-3" label="Publish date">
            {{ task.publish }}
          </base-input>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-12">
          <base-input class="mb-3" label="Response">
            {{ task.response }}
          </base-input>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-12">
          <base-input class="mb-3" label="Notes">
            {{ task.studentnotes }}
          </base-input>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-12">
          <div
            v-for="file in task.responsefiles"
            :key="file.name"
            style="font-size: 12px"
          >
            <a target="blank" :href="fileurl + file.name">
              <i class="text-black ni file-text"></i>
              {{ file.name.substring(file.name.indexOf("_") + 1) }}
            </a>
          </div>
        </div>
      </div>
    </modal>

    <modal :show.sync="modalresult" size="sm">
      <h6 slot="header" class="modal-title">Result</h6>
      <div class="row">
        <div class="col-lg-6">
          <base-input label="Mark" class="mr-1">
            <el-select
              class="select-primary pagination-select"
              v-model="result.mark"
            >
              <el-option
                class="select-primary"
                v-for="item in marks"
                :key="item"
                :label="item"
                :value="item"
              ></el-option>
            </el-select>
          </base-input>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-12">
          <base-input label="Notes" class="mr-1">
            <textarea
              class="form-control"
              rows="3"
              resize="none"
              v-model="result.teachernotes"
            ></textarea>
          </base-input>
        </div>
      </div>
      <div class="row" v-if="mark === '0'">
        <div class="col-lg-12" style="text-align: center">
          <base-button type="primary" @click.native="onSave">Save</base-button>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import swal from "sweetalert2";
import { Table, TableColumn, Select, Option } from "element-ui";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import { GetHomeworkByTeacher, UpdateReview } from "../../../services/homework";
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import { GetTeachers } from "../../../services/user";
import {
  ShowLink,
  HtmlNewLine,
  fileUrl,
  DateTimeToString,
} from "../../../services/helper";
export default {
  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    Loading,
    flatPicker,
  },
  computed: {
    fileurl() {
      return fileUrl;
    },
  },
  data() {
    return {
      teachers: [],
      tableData: [],
      filter: {
        start: new Date(),
        end: new Date(),
        id: "",
        searchtype: 1,
      },
      filter2: 1,
      mark: "0",
      search: "",
      modaltask: false,
      modalresponse: false,
      modalresult: false,
      task: {},
      result: {
        mark: "0",
      },
      isLoading: false,
      marks: ["0", "1", "2", "3", "4", "5"],
    };
  },
  methods: {
    onRefresh() {
      this.onGo();
    },
    isactual(dt) {
      let d = new Date(dt);
      let n = new Date();
      if (parseInt((d - n) / (24 * 3600 * 1000)) > 7) return false;
      else return true;
    },
    onEdit(index, row) {
      this.$router
        .push({ path: "/manager/payment/" + row.id })
        .catch((e) => {});
    },
    onSave() {
      if (this.result.mark === "0") return;
      this.isLoading = true;
      UpdateReview(this.result).then((response) => {
        this.isLoading = false;
        if (response.data.result) {
          this.modalresult = false;
          this.onGo();
        }
      });
    },
    onGo() {
      this.isLoading = true;
      GetHomeworkByTeacher(this.filter).then((response) => {
        this.isLoading = false;
        if (response.data.result) {
          this.tableData = response.data.result;
        } else {
          this.tableData = [];
          if (response.data) this.notifyVue("danger", response.data);
        }
      });
    },
  },
  mounted() {
    this.filter.start = new Date(this.filter.start).setDate(
      new Date(this.filter.start).getDate() - 14
    );
    this.filter.end = new Date();
    GetTeachers().then((response) => {
      if (response.data !== null) {
        this.teachers = response.data.result;
      }
    });
  },
};
</script>

<style lang="scss" scoped>
</style>